import { render } from "./headLine.vue?vue&type=template&id=6ce6db22&scoped=true"
import script from "./headLine.vue?vue&type=script&lang=js"
export * from "./headLine.vue?vue&type=script&lang=js"

import "./headLine.vue?vue&type=style&index=0&id=6ce6db22&lang=less&scoped=scoped"

import exportComponent from "F:\\project\\zifeiluntang\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ce6db22"]])

export default __exports__